import { useDataChange, useDataValue } from 'Simple/Data.js'
export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'requirement',
  })
  return function onChange() {
    change(next => {
      next.new_task = {
        ...next.new_task,
        actions: [{ id: 'letter', document_template_id: null }],
      }
    })
  }
}
